module.exports = __webpack_public_path__ + "static/img/7.5baba1d8.jpg";